import { ZomentumEntities } from "../common";
import {
	PartialAutomationFilterMetadataV2,
	TriggerActionEntityTypes
} from "./../Others/SalesActivity/index";
import {
	SalesActivityAutomation,
	SalesActivityAutomationFilterCriteriaCombinerTypes,
	SalesActivityAutomationMetadataFilter,
	SalesActivityAutomationTriggerActionTypes,
	AutomationFilterMetadataV2
} from "../Others/SalesActivity/index";
import { UserData } from "../Users";

export enum DocumentApproverType {
	FixedSet = "fixed_set",
	AllAdmins = "all_admin"
}

export class ApprovalAutomationDetails {
	document_approver_type: DocumentApproverType =
		DocumentApproverType.FixedSet;
	approver_user_ids?: string[] = new Array<string>();
}

export type DocumentApprovalInterface = Omit<
	SalesActivityAutomation,
	"actions" | "allow_rule_trigger" | "filter_criteria"
>;

export class DocumentApproval implements DocumentApprovalInterface {
	id = "";
	company_id = "";
	deleted = false;
	created: Date = new Date();
	updated: Date = new Date();
	creator_user_id = "";
	creator_user: UserData = new UserData();
	trigger_entity_type: TriggerActionEntityTypes | null = null;
	trigger_action_type: SalesActivityAutomationTriggerActionTypes | null =
		null;
	filter_criteria?: SalesActivityAutomationMetadataFilter[] = [];
	filter_groups?: AutomationFilterMetadataV2[][] = [];
	is_enabled = false;
	filter_criteria_combiner: SalesActivityAutomationFilterCriteriaCombinerTypes | null =
		null;
	title = "";
	description = "";
	trigger_popover_visible = false;
	approver_automation_details: ApprovalAutomationDetails =
		new ApprovalAutomationDetails();
}

export interface DocumentApprovalCreateRequest {
	filter_criteria?: Partial<SalesActivityAutomationMetadataFilter>[];
	is_enabled: boolean;
	title: string;
	description?: string;
	filter_criteria_combiner: SalesActivityAutomationFilterCriteriaCombinerTypes | null;
	document_approver_type: DocumentApproverType;
	approver_user_ids?: string[];
	filter_groups?: PartialAutomationFilterMetadataV2[][];
}

export interface DocumentApprovalUpdateRequest
	extends DocumentApprovalCreateRequest {
	id: string;
}

export interface DocumentApproverDrawerFormValues {
	document_approver_type?: boolean;
	approver_user_ids?: string[];
}

export interface DocumentApprovalRulesResponse {
	data: DocumentApproval[];
	filtered_map_count: null;
}

export const UpdatedFilterNameMap: Partial<Record<ZomentumEntities, string>> = {
	[ZomentumEntities.DocumentBlock]: "Quote Line Items"
};
